import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { refreshRequest, pingRequest } from '@defi/core-auth';
import Auth from '@defi/core-auth';
//import Token from '../../utils/token';
import { PATH_DASHBOARD, REQUIRE_AUTH } from '@defi/core-constants';
export default function (ComposedComponent) {
  let editOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let ignorePermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let AppContext = arguments.length > 3 ? arguments[3] : undefined;
  function checkExpiration() {
    // Get expiration and current timestamp
    const refreshTimeStamp = localStorage.refresh ? Number(localStorage.refresh) : 0;
    const currentTime = new Date().getTime();
    const currentTimeStamp = Math.floor(currentTime / 1000);
    return currentTimeStamp > refreshTimeStamp;
  }
  class Authentication extends React.Component {
    constructor(props) {
      super(props);
      this.authorized = true;
      if (REQUIRE_AUTH) {
        // Verify all permissions and fields
        this.authorized = Auth.verification(window.location.pathname, editOnly, ignorePermissions);
        if (!this.authorized) {
          window.location.replace(PATH_DASHBOARD);
          return;
        }

        // Check for expiration running low
        if (checkExpiration()) {
          this.props.dispatch(refreshRequest());
        }

        // Run a ping to check user cookies
        props.dispatch(pingRequest());
      }
    }
    render() {
      if (!this.authorized) {
        return null;
      }
      return /*#__PURE__*/React.createElement(ComposedComponent, Object.assign({
        context: AppContext
      }, this.props));
    }
  }
  Authentication.contextTypes = {
    router: object
  };
  return connect()(Authentication);
}